<template>
  <header class="header-game">
    <div class="container">
      <div class="header-game__back" @click="goBack" v-if="back">
        <img src="@/assets/chevron.svg" alt="">
      </div>
      <div class="header-game__title" v-if="selectGame.teamLocal != undefined && selectGame.teamVisitor != undefined">
        {{selectGame.teamLocal.name}} vs {{selectGame.teamVisitor.name}}
      </div>
      <div class="header-game__close" @click="closeGame" v-if="close">
        <img src="@/assets/close.svg" alt="">
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    back: Boolean,
    close: Boolean
  },
  computed: {
    ...mapState({
      selectGame: state => state.InfoModule.selectGame
    })
  },
  mounted() {
    if (Object.keys(this.selectGame).length == 0) {
      this.$store.dispatch('getGame', { id: this.$route.params.id })
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    closeGame() {
      this.$store.dispatch('openModalExitGame')
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.header-game {
  height: 64px;
  width: 100%;
  position: fixed;
  top: 0;
  padding: $margin-basedo 0;
  color: $white;
  z-index: 4;
  background: linear-gradient($darkblue, #21012b00);

  @media (min-width: $break-lg) {
    height: 80px;
    padding: 28px 0;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  &__back {
    left: 0;
    position: absolute;
    cursor: pointer;
    padding: $margin-base;
  }

  &__close {
    right: 0;
    position: absolute;
    cursor: pointer;
    padding: $margin-base;
  }

  &__title {
    @include font-settings(kilo, base);
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 $margin-mega;
  }
}
</style>